import { Component, Input, OnInit } from '@angular/core';
import * as fromRoot from '@app/reducers';
import { Customization } from '@app/shared/models/customization';
import { Device } from '@app/shared/models/device';
import { Promotion } from '@app/shared/models/promotion';
import { Store } from '@ngrx/store';
import { GoogleTagManagerService } from '@app/core/lib/google-tag-manager/angular-google-tag-manager.service';
import { merge, Observable, of } from 'rxjs';
import { delay, mapTo } from 'rxjs/operators';
import { Constant } from 'src/constant';
import * as fromViewer from '../reducers/viewer.reducer';

@Component({
  selector: 'app-downloader',
  templateUrl: './downloader.component.html',
  styleUrls: ['./downloader.component.scss']
})
export class DownloaderComponent implements OnInit {

  @Input() device: Device;
  @Input() customization: Customization;

  promotion$: Observable<Promotion>;
  state = 'loadingNotStarted';
  hasPromotion = false;
  replay = false;
  promotionHeight: number;
  showOverlay: boolean;
  showVideo: boolean;
  progressAnimation = of(null);

  constructor(
    private store$: Store<fromRoot.State & fromViewer.State>,
    private gtmService: GoogleTagManagerService
  ) {
    this.promotion$ = this.store$.select(fromViewer.getPromotion);
    this.promotion$.subscribe(promotion => {
      if (!!promotion) {
        this.hasPromotion = true;
        this.resolveLoadingState(this.progressAnimation);
        this.gtmService.pushTag({
          event: Constant.eventGTM.EXTERNAL_PROMOTION_DISPLAYED,
          promotion_title: promotion.title,
          promotion_id: promotion.id,
          promotion_target: promotion.target,
          promotion_link: promotion.link,
          promotion_language: promotion.language,
          smashPromotionTitle: promotion.title,
          smashPromotionId: promotion.id,
          smashPromotionTarget: promotion.target,
          smashPromotionCtaUrl: promotion.link,
          smashPromotionCtaLabel: promotion.button,
          smashPromotionLanguage: promotion.language,
        });
      }
    });
  }

  ngOnInit(): void {
    if (this.customization) {
      this.showOverlay = true;
    }
  }

  isVideoBgReadyToPlay(event): void {
    this.showVideo = true;
  }

  private resolveLoadingState(progress: Observable<null>) {
    this.setAnimation(progress).subscribe((val: string) => {
      this.state = val;
      if (val === 'loadingFinished') {
        this.toggleTeaserMessage();
      }
    });
  }

  private setAnimation(progress: Observable<null>) {
    const message = merge(
      progress.pipe(
        mapTo('loadingStarted'),
        delay(100)
      ),
      progress.pipe(
        mapTo('loadingFinished'),
        delay(2500)
      )
    );
    return message;
  }

  private toggleTeaserMessage() {
    this.replay = true;
    // setTimeout(() => {
    //   this.replay = false;
    // }, 3000);
  }
}
